export function add_parallax_to_image( el ) {
  document.addEventListener('scroll', () => {
    el.style.top = window.scrollY + 'px';
  }, {passive: true});
}
